import { AfterViewInit, Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { Color } from '@app/shared/models/color.model';
import { Style, Size } from '../icon/icon.component';

export interface FileInputStyle {
  hoverColor?: Color;
  hoverBackgroundColor?: Color;
  inputColor?: Color;
  inputBackgroundColor?: Color;
}

@Component({
  selector: 'app-file-input',
  templateUrl: './file-input.component.html',
  styleUrls: ['./file-input.component.scss'],
  standalone: false,
})
export class FileInputComponent implements AfterViewInit {
  @Output() importFile = new EventEmitter<FileList>();

  @Input() extensions: string[] = [];
  @Input() style: FileInputStyle = {};
  @Input() maxFiles: number = 0;
  @Input() maxFileSize: number = 0;

  @ViewChild('upload') element!: ElementRef<HTMLInputElement>;

  over: boolean = false;
  errorMessage: string = '';

  protected readonly Style = Style;
  protected readonly Size = Size;

  ngAfterViewInit(): void {
    Object.entries(this.style).forEach(([name, value]) => {
      this.element.nativeElement.style.setProperty(`--${name}`, value);
    });
  }

  dropFile($event: Event) {
    $event.preventDefault();
    $event.stopPropagation();
    const dragEvent = $event as DragEvent;
    const { files } = dragEvent.dataTransfer! || $event.target;
    if (!this.validateFile(files)) {
      return;
    }
    this.importFile.emit(files);
  }

  validateFile(files: FileList): boolean {
    if (this.maxFiles > 0 && files.length > this.maxFiles) {
      this.errorMessage = `Vous ne pouvez importer que ${this.maxFiles} fichiers maximum.`;
      return false;
    }

    if (this.extensions.length > 0 && !Array.from(files).every((file) => this.extensions.includes(file.type))) {
      this.errorMessage = 'Extension invalide.';
      return false;
    }

    if (this.maxFileSize > 0 && !Array.from(files).every((file) => file.size <= this.maxFileSize)) {
      this.errorMessage = `Chaque fichier doit être inférieur à ${this.maxFileSize / (1024 * 1024)} Mo.`;
      return false;
    }

    this.errorMessage = '';
    return true;
  }
}
